/**
 * 文字列を一文字ずつ<span>で囲む関数
 * @param {String} str
 * @return {String}
 */
export const wrapCharSpan = (str) => {
  return [...str].map(char => `<span>${char}</span>`).join('');
}
